export enum RoutesEnum {
  COCKPIT = '/cockpit',
  LOGIN = '/login',
  DISPLAY_MODE = '/display-mode',
  SCREEN = '/screen',
}
